import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {GlobalValidator} from '../../../shared/validators/global-validator';
import {ThingsService} from "../../things.service";
import {NotificationType} from "../../../core/notify/index";
import {NotificationBarService} from "../../../core/notify/notification.service";

@Component({
  selector: 'nuc-offline-threshold',
  templateUrl: './offline-threshold.component.html',
  styleUrls: ['./offline-threshold.component.scss']
})
export class OfflineThresholdComponent implements OnInit, OnChanges {

  private isFormSubmitted: boolean;
  isThresholdEdit = false;
  form;
  value;
  unit;
  isEmptyState = true;
  unitArray = [];
  @Input() thing;
  @Output() onThingUpdate: EventEmitter<any> = new EventEmitter();
  formErrors = {
    'value': '',
  };
  validationMessages = {
    'value': {
      'required': 'THING_DETAILS.VALIDATIONS.REQUIRED',
      'integerValidation': 'THING_DETAILS.VALIDATIONS.INTEGER' ,
      'min': 'THING_DETAILS.VALIDATIONS.MIN',
      'max':'THING_DETAILS.VALIDATIONS.MAX'
    }
  };

  constructor(private fb: FormBuilder,
              private thingService: ThingsService,
              private notifier: NotificationBarService) { }
  ngOnInit() {
    this.buildForm();
    this.unitArray = ['sec', 'min', 'hours', 'days'];
  }
  ngOnChanges() {
    this.setUnitAndValue(this.thing.offlineThreshold);
    this.isEmptyState = this.thing.offlineThreshold === 0 ? true : false;
  }
  buildForm() {
    this.form = this.fb.group({'value': ['', [
       GlobalValidator.integerValidation,
       Validators.required,
      GlobalValidator.min(1),
      GlobalValidator.max(1000)
      ]],
    'unit': [0, [Validators.required]]});

    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
  }
  editIsThreshold() {
    this.isThresholdEdit = true;
    this.isEmptyState = false;
    this.setUnitAndValue(this.thing.offlineThreshold);
  }

  cancelEdit() {
    this.isThresholdEdit = false;
    this.form.reset({'unit': 0});
    this.isEmptyState = this.thing.offlineThreshold === 0 ? true : false;
  }

  updateThreshold() {
    let multiFactor = 1000;
     if (!this.form.valid || this.isFormSubmitted) {
       return;
     }
     switch (parseInt(this.form.controls['unit'].value, 10)) {
       case 1:
         multiFactor *= 60;
         break;
       case 2:
         multiFactor *= (60 * 60);
         break;
       case 3:
         multiFactor *= (60 * 60 * 24);
         break;
     }
     this.isFormSubmitted = true;
     this.thing.offlineThreshold = multiFactor * this.form.controls['value'].value;
     this.thingService.updateThing(this.thing)
       .subscribe((response) => {
         this.isFormSubmitted = false;
         this.thing = response.data;
         this.isThresholdEdit = false;
         this.notifier.create({message: response.status.message, type: NotificationType.Success});
         this.setUnitAndValue(this.thing.offlineThreshold);
         this.onThingUpdate.next(response.data);
       });
  }
  private setUnitAndValue(threshold) {
    if ( threshold === 0 || isNaN(threshold)) {
      return;
    }
    let dividend = threshold / 1000,
        counter = 0,
        divisor = 60;
    while (dividend % divisor === 0) {
      dividend /= divisor;
      counter++;
      divisor = counter === 2 ? 24  : 60;
    }
    this.value = dividend;
    this.unit = this.unitArray[counter];
    if (this.form) {
      this.form.controls['value'].setValue(this.value);
      this.form.controls['unit'].setValue(counter);
    }
  }

  onValueChanged(data?: any) {
    const form = this.form;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && (control.dirty && !control.valid)) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
          break;
        }
      }

    }
  }


}



// WEBPACK FOOTER //
// ./src/app/things/things-details/offline-threshold/offline-threshold.component.ts